﻿import i18next from 'i18next';
import { toastErroCarregar } from '../utilidades/toastErroCarregar';
import { removeCacheUsuarioLogado } from '../utilidades/usuarioLogado';
import { uuid } from '../utilidades/uuid';

export const googleLogin = {
    handleGoogleLoginCallback(response) {
        document.dispatchEvent(new CustomEvent('googleLoginResposta', { detail: { response } }));
    },
    renderizarBotaoLogin(clientId = null, hotsiteUrl = null, urlCallback = null) {
        const botao = document.getElementById("botao-google-login");
        if (!botao) {
            console.error('Botão google login não encontrado!');
            return;
        }
        //Se estiver dentro de um hotsite, cria o botão manualmente
        if (hotsiteUrl) {
            botao.classList.add('botao-custom-google-login');
            botao.innerHTML = `<span class="ps-3 text-center w-100">${i18next.t('BotaoGoogleLoginTexto')}</span>`;
            botao.addEventListener('click', (e) => {

                const state = uuid();
                localStorage.setItem('googleAuthState', state);
                const link = `https://accounts.google.com/o/oauth2/auth?state=${state}&client_id=${clientId}&redirect_uri=${urlCallback}&scope=email profile&response_type=code`;
                const width = 500;
                const height = 600;
                const left = (window.screen.width - width) / 2;
                const top = (window.screen.height - height) / 2;

                window.open(
                    link,
                    'Google Login',
                    `width=${width},height=${height},top=${top},left=${left}`
                );
            });
        }
        else {
            google.accounts.id.renderButton(botao, { theme: "outline", size: "large", width: '340' });
        }
    },
    callbacksWindow: {
        googleAutenticacaoErro(response) {
            toastErroCarregar(i18next.t('LoginErro'));
        },
        googleAutenticacaoSucesso(response) {
            removeCacheUsuarioLogado();
            if (!response.state) {
                toastErroCarregar(i18next.t('LoginErro'));
                return;
            }
            const storedState = localStorage.getItem('googleAuthState');
            if (response.state !== storedState) {
                toastErroCarregar(i18next.t('LoginErro'));
                return;
            }
            googleLogin.handleGoogleLoginCallback(response);
        }
    },
    async init() {
        const googleGsiClientScript = document.getElementById('google-gsi-client-script');
        if (!googleGsiClientScript) {
            console.error("Script do Google Services Identity não carregado!");
            return;
        }

        const googleClientId = googleGsiClientScript.getAttribute('data-id');
        const hotsiteUrl = googleGsiClientScript.getAttribute('data-hotsite') ?? null;
        const urlCallback = googleGsiClientScript.getAttribute('data-url-callback') ?? null;

        await google.accounts.id.initialize({
            client_id: googleClientId,
            callback: this.handleGoogleLoginCallback,
            cancel_on_tap_outside: false,
            itp_support: true,
            nonce: uuid(),
            use_fedcm_for_prompt: true
        });

        document.addEventListener('renderizarBotaoGoogleLogin', () => {
            this.renderizarBotaoLogin(googleClientId, hotsiteUrl, urlCallback);
        });

        document.addEventListener('solicitarGoogleLoginOneTap', () => {
            //Somente usa o OneTap no empregare.com
            if (hotsiteUrl) {
                return;
            }

            if (window.location.pathname.includes('cadastrar-curriculo')) {
                return;
            }
            
            google.accounts.id.prompt();
        });

        document.addEventListener('googleLoginLogadoDentroDaVaga', async (e) => {
            const { salvarCandidaturaPendente } = await import('../utilidades/candidaturaPendente');

            removeCacheUsuarioLogado();

            const { vagaID, vagaTitulo, vagaUrl, vagaStatus } = e.detail;

            if (vagaStatus) { //Se esse valor estiver preenchido é porque não é para add a candidatura
                return;
            }
            
            await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
        });

        if (window.location.pathname.includes('/login')) {
            document.dispatchEvent(new CustomEvent('renderizarBotaoGoogleLogin'));
        }

        window.addEventListener('message', (e) => {
            if (this.callbacksWindow[e.data.type]) {
                this.callbacksWindow[e.data.type](e.data.response);
            }
        });
    }
}